var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkOpenFloatingButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_18099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.191406,
    y: 0.35376,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_18099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19141 22.3538C5.64141 22.3538 5.17074 22.1581 4.77941 21.7668C4.38741 21.3748 4.19141 20.9038 4.19141 20.3538V4.35376C4.19141 3.80376 4.38741 3.33276 4.77941 2.94076C5.17074 2.54943 5.64141 2.35376 6.19141 2.35376H18.1914C18.7414 2.35376 19.2124 2.54943 19.6044 2.94076C19.9957 3.33276 20.1914 3.80376 20.1914 4.35376V20.3538C20.1914 20.9038 19.9957 21.3748 19.6044 21.7668C19.2124 22.1581 18.7414 22.3538 18.1914 22.3538H6.19141ZM6.19141 20.3538H18.1914V4.35376H16.1914V11.3538L13.6914 9.85376L11.1914 11.3538V4.35376H6.19141V20.3538Z",
    fill: "#4267F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOpenFloatingButton);
export default __webpack_public_path__ + "static/media/bookmark_open_floating_button.636d63a664b687aec41b54734502d8c6.svg";
export { ForwardRef as ReactComponent };